import classNames from 'classnames'
import { h, JSX } from 'preact'

export interface LoaderProps {
    // If you want to animate opacity transition, render as hidden when not needed
    isHidden?: boolean
}

export const Loader = ({ isHidden }: LoaderProps): JSX.Element => (
    <div class={classNames('loader', { 'loader--hidden': isHidden })}>
        <div class="loader__inner">
            {[1, 2, 3, 4].map((i) => (
                <div key={i} class="loader__circle"></div>
            ))}
        </div>
    </div>
)
